import { FC } from "react"
import { Success } from "../components/Success"
import { useLocation } from "react-router-dom"

export const RegistrationSuccessPage: FC = () => {
  const location = useLocation();

  return <Success success={location.state.success} />;
};
